import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./dashboard";
import AdmissionsToolkit from "./admissionstoolkit";
import PrivacyPolicy from "./privacypolicy";
import Profile from "./profile";
import Login from "./login";
import Register from "./register";
import PublicPolicy from "./publicpolicy";
import { useAuth } from "./AuthContext";
import LaunchXFeature from "./LaunchXFeature";
import { Navigate } from "react-router-dom";



function App() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const { user, loading } = useAuth();
  const isAuthenticated = !!user;

  if (loading) {
    return <p className="text-center mt-10">Loading...</p>;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
  path="/"
  element={<Navigate to="/admissionstoolkit" replace />}
/>
      <Route path="/admissionstoolkit" element={<AdmissionsToolkit />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/public" element={<PublicPolicy />} />
      <Route path="/programs" element={<LaunchXFeature />} />

      {/* Protected route */}
      <Route
        path="/profile"
        element={
          isAuthenticated ? (
            <Profile
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          ) : (
            <Login />
          )
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Dashboard />} />
    </Routes>
  );
}

export default App;